/* eslint-disable react/jsx-key, react-native/no-inline-styles */

import React from "react"

import { EmptyState } from "../../../components"
import { colors } from "../../../theme"
import { DemoDivider } from "../DemoDivider"
import { Demo } from "../DemoShowroomScreen"
import { DemoUseCase } from "../DemoUseCase"
export const DemoEmptyState: Demo = {
  name: "EmptyState",
  description: "A component to use when there is no data to display. It can be utilized to direct the user what to do next",
  data: [
    <DemoUseCase
      description="You can create different text/image sets. One is predefined called `generic`. Note, there's no default in case you want to have a completely custom EmptyState."
      name="Presets"
    >
      <EmptyState preset="generic" />
    </DemoUseCase>,

    <DemoUseCase
      description="There are a few different ways to pass content."
      name="Passing Content"
    >
      <EmptyState
        content="You can pass in any image source."
        heading="Customize Image"
        imageSource={require("../../../../assets/images/logo.png")}
      />

      <DemoDivider
        line={true}
        size={30}
      />

      <EmptyState
        button="Via `button` Prop"
        content="Via `content` prop."
        heading="Via `heading` Prop"
      />

      <DemoDivider
        line={true}
        size={30}
      />

      <EmptyState
        buttonTx="demoShowroomScreen.demoViaSpecifiedTxProp"
        buttonTxOptions={{ prop: "button" }}
        contentTx="demoShowroomScreen.demoViaSpecifiedTxProp"
        contentTxOptions={{ prop: "content" }}
        headingTx="demoShowroomScreen.demoViaSpecifiedTxProp"
        headingTxOptions={{ prop: "heading" }}
      />
    </DemoUseCase>,

    <DemoUseCase
      description="The component can be styled easily."
      name="Styling"
    >
      <EmptyState
        ImageProps={{ resizeMode: "contain" }}
        buttonStyle={{ alignSelf: "center", backgroundColor: colors.palette.neutral100 }}
        buttonTextStyle={{ color: colors.error }}
        imageStyle={{ height: 75, tintColor: colors.palette.neutral100 }}
        preset="generic"
        style={{ backgroundColor: colors.error, paddingVertical: 20 }}
        ButtonProps={{
          preset: "reversed",
        }}
        contentStyle={{
          color: colors.palette.neutral100,
          textDecorationLine: "underline",
          textDecorationColor: colors.palette.neutral100,
        }}
        headingStyle={{
          color: colors.palette.neutral100,
          textDecorationLine: "underline",
          textDecorationColor: colors.palette.neutral100,
        }}
      />
    </DemoUseCase>,
  ],
}

// @demo remove-file
